import { render, staticRenderFns } from "./AfterSalesManage.vue?vue&type=template&id=6c1883ec&"
import script from "./AfterSalesManage.vue?vue&type=script&lang=js&"
export * from "./AfterSalesManage.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesManage.vue?vue&type=style&index=0&id=6c1883ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports